module.exports = __webpack_public_path__ + "img/e_2_1_r.977c891e.png";